/**
 * Impresión de reporte de caja abierta y cierre de caja.
 */

function getUserDisplayName(win) {
	const ej = win.posknEjecutorFacturacion || {};
	return ej.nombre || 'Cajero';
}

const PRINT_STYLES = `
body { margin: 0; padding: 20px; font-family: 'Courier New', monospace; font-size: 12px; line-height: 1.4; color: #000 !important; font-weight: bold !important; }
.reporte-impresion { position: static; width: 100%; color: #000 !important; font-weight: bold !important; }
.reporte-header { text-align: center; border-bottom: 3px solid #000; padding-bottom: 10px; margin-bottom: 15px; }
.reporte-titulo { font-size: 18px; font-weight: 900 !important; margin: 0; color: #000 !important; text-shadow: 1px 1px 0px #000; }
.reporte-fecha { font-size: 12px; margin: 5px 0 0 0; font-weight: bold !important; color: #000 !important; }
.reporte-seccion { margin: 15px 0; }
.reporte-seccion-titulo { font-weight: 900 !important; font-size: 14px; border-bottom: 2px solid #000; padding-bottom: 3px; margin-bottom: 8px; color: #000 !important; text-transform: uppercase; }
.reporte-linea { display: flex; justify-content: space-between; margin: 4px 0; border-bottom: 1px solid #000; padding-bottom: 3px; font-weight: bold !important; color: #000 !important; }
.reporte-linea span { font-weight: bold !important; color: #000 !important; }
.reporte-total { font-weight: 900 !important; font-size: 16px; border-top: 3px solid #000; border-bottom: 3px solid #000; padding: 8px 0; margin: 15px 0; text-align: center; color: #000 !important; text-shadow: 1px 1px 0px #000; }
.reporte-footer { text-align: center; font-size: 10px; margin-top: 20px; border-top: 2px solid #000; padding-top: 10px; font-weight: bold !important; color: #000 !important; }
.reporte-footer p { font-weight: bold !important; color: #000 !important; margin: 2px 0; }
* { color: #000 !important; font-weight: bold !important; }
@media print { body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color: #000 !important; font-weight: bold !important; } * { color: #000 !important; font-weight: bold !important; } }
`;

function openPrintWindow(win, title, htmlBody, onSuccess, kind) {
	const fullHtml = `
		<!DOCTYPE html>
		<html>
		<head>
			<title>${title}</title>
			<meta charset="UTF-8">
			<style>${PRINT_STYLES}</style>
		</head>
		<body>${htmlBody}</body>
		</html>
	`;
	if (typeof win.posknPrint === 'function') {
		win.posknPrint({
			title,
			html: fullHtml,
			kind: kind || 'reporte',
			onSuccess,
		});
		return;
	}
	const ventanaImprimir = win.open('', '_blank', 'width=800,height=600');
	if (!ventanaImprimir) {
		const msg = 'Error: No se pudo abrir ventana de impresión. Revisa el bloqueador de pop-ups.';
		if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion(msg, 'error');
		else win.alert(msg);
		return;
	}
	ventanaImprimir.document.write(fullHtml);
	ventanaImprimir.document.close();
	setTimeout(() => {
		try {
			ventanaImprimir.print();
			setTimeout(() => ventanaImprimir.close(), 2000);
			if (typeof onSuccess === 'function') onSuccess();
		} catch (_e) {
			if (typeof win.mostrarNotificacion === 'function') {
				win.mostrarNotificacion('Error al enviar a impresión', 'error');
			}
		}
	}, 1000);
}

export function attachCajaPrintGlobals(win) {
	win.imprimirReporteCaja = function imprimirReporteCaja() {
		if (!win.datosReporte) {
			const msg = 'No hay datos para imprimir';
			if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion(msg, 'error');
			else win.alert(msg);
			return;
		}

		const datos = win.datosReporte;
		const ahora = new Date();
		const fechaReporte = `${ahora.toLocaleDateString('es-ES')} ${ahora.toLocaleTimeString('es-ES')}`;
		const usuarioActual = getUserDisplayName(win);
		const fmt = win.formatearNombreMetodo;
		const sym = win.obtenerSimboloMoneda;

		let reporteHtml = `
			<div class="reporte-impresion">
				<div class="reporte-header">
					<h1 class="reporte-titulo">REPORTE DE CAJA</h1>
					<p class="reporte-fecha">Fecha: ${fechaReporte}</p>
					<p class="reporte-fecha">Usuario: ${usuarioActual}</p>
					<p class="reporte-fecha">Caja ID: ${datos.basica.caja_id}</p>
				</div>
				<div class="reporte-seccion">
					<div class="reporte-seccion-titulo">INFORMACIÓN GENERAL</div>
					<div class="reporte-linea"><span>Fecha Apertura:</span><span>${datos.basica.fecha_apertura ? new Date(datos.basica.fecha_apertura).toLocaleString('es-ES') : 'No disponible'}</span></div>
					<div class="reporte-linea"><span>Monto Inicial:</span><span>$${parseFloat(datos.basica.monto_inicial || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Total Pedidos:</span><span>${datos.basica.pedidos_count || 0}</span></div>
					<div class="reporte-linea"><span>Total Ventas:</span><span>$${parseFloat(datos.basica.ventas_dia || datos.detalles.total || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Total Egresos:</span><span>${(() => {
						const usd = parseFloat(datos.basica.gastos_dia_usd != null ? datos.basica.gastos_dia_usd : datos.basica.gastos_dia || 0).toFixed(2);
						const bs = parseFloat(datos.basica.gastos_dia_bs || 0).toFixed(2);
						return parseFloat(bs) > 0 ? `$${usd} / Bs. ${bs}` : `$${usd}`;
					})()}</span></div>
					<div class="reporte-linea"><span>Total Reembolsos:</span><span style="color: #dc3545;">-$${parseFloat(datos.basica.reembolsos_dia || datos.detalles.reembolsos_total || 0).toFixed(2)}</span></div>
				</div>`;

		if (datos.detalles.metodos_pago && Object.keys(datos.detalles.metodos_pago).length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">MÉTODOS DE PAGO</div>`;
			Object.entries(datos.detalles.metodos_pago).forEach(([metodo, monto]) => {
				reporteHtml += `<div class="reporte-linea"><span>${fmt(metodo)}:</span><span>${sym(metodo)}${parseFloat(monto).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		const creditosDia = parseFloat(datos.detalles.creditos_total || 0);
		const creditosListaRep = datos.detalles.creditos_pedidos || [];
		if (creditosDia > 0 || creditosListaRep.length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">CRÉDITOS</div>`;
			reporteHtml += `<div class="reporte-linea"><span>Total a crédito:</span><span style="color:#c62828;">$${creditosDia.toFixed(2)}</span></div>`;
			creditosListaRep.forEach((c) => {
				const num = String(c.numero || c.order_id || '');
				const cli = String(c.cliente || '').trim();
				reporteHtml += `<div class="reporte-linea"><span>#${num}${cli ? ` · ${cli}` : ''}:</span><span style="color:#c62828;">$${parseFloat(c.monto || 0).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		const abonosUsdRep = parseFloat(datos.detalles.abonos_credito_total_usd || 0);
		const abonosBsRep = parseFloat(datos.detalles.abonos_credito_total_bs || 0);
		const abonosListaRep = datos.detalles.abonos_credito || [];
		if (abonosUsdRep > 0 || abonosBsRep > 0 || abonosListaRep.length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">ABONOS DE CRÉDITO</div>`;
			reporteHtml += `<div class="reporte-linea"><span>Total cobrado:</span><span>$${abonosUsdRep.toFixed(2)}${abonosBsRep > 0 ? ` / Bs. ${abonosBsRep.toFixed(2)}` : ''}</span></div>`;
			reporteHtml += `<div class="reporte-linea"><span>Nota:</span><span>Incluidos en métodos de pago</span></div>`;
			abonosListaRep.forEach((a) => {
				const mon = String(a.moneda || 'USD').toUpperCase() === 'BS' ? 'Bs. ' : '$';
				const met = a.metodo_pago ? ` · ${fmt(a.metodo_pago)}` : '';
				reporteHtml += `<div class="reporte-linea"><span>${a.descripcion || 'Abono'}${met}:</span><span>${mon}${parseFloat(a.monto || 0).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		if (datos.detalles.productos_vendidos?.length) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">PRODUCTOS VENDIDOS</div>`;
			datos.detalles.productos_vendidos.forEach((producto) => {
				const qty = parseInt(producto.quantity, 10) || 0;
				const name = String(producto.name || '').normalize('NFC');
				reporteHtml += `<div class="reporte-linea"><span>${qty}x ${name}:</span><span>$${parseFloat(producto.total).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		if (datos.detalles.gastos?.length) {
			const gastosReporte = datos.detalles.gastos.filter(
				(g) => String(g.categoria || '').toLowerCase() !== 'abono-credito',
			);
			if (gastosReporte.length) {
				reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">GASTOS DEL DÍA</div>`;
				gastosReporte.forEach((gasto) => {
					const moneda = (gasto.moneda || 'USD').toUpperCase();
					const montoStr = parseFloat(gasto.monto).toFixed(2);
					const montoFormateado = moneda === 'BS' ? `Bs. ${montoStr}` : `$${montoStr}`;
					reporteHtml += `<div class="reporte-linea"><span>${gasto.descripcion} (${gasto.categoria}):</span><span>${montoFormateado}</span></div>`;
				});
				reporteHtml += `</div>`;
			}
		}

		const totalReembolsos = parseFloat(datos.detalles.reembolsos_total || datos.basica.reembolsos_dia || 0);
		const reembolsosLista = datos.detalles.reembolsos || [];
		if (totalReembolsos > 0 || reembolsosLista.length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">REEMBOLSOS DEL DÍA</div>`;
			if (reembolsosLista.length > 0) {
				reembolsosLista.forEach((reembolso) => {
					let descripcionMostrar = reembolso.descripcion || 'Reembolso';
					const matchPedido = descripcionMostrar.match(/#(\d+)/);
					if (matchPedido) descripcionMostrar = `Reembolso - Pedido #${matchPedido[1]}`;
					reporteHtml += `<div class="reporte-linea"><span>${descripcionMostrar}:</span><span style="color: #dc3545;">-$${parseFloat(reembolso.monto).toFixed(2)}</span></div>`;
				});
			} else if (totalReembolsos > 0) {
				reporteHtml += `<div class="reporte-linea"><span>Total Reembolsos:</span><span style="color: #dc3545;">-$${totalReembolsos.toFixed(2)}</span></div>`;
			}
			if (totalReembolsos > 0) {
				reporteHtml += `<div class="reporte-linea" style="font-weight: bold; border-top: 1px solid #ddd; margin-top: 5px; padding-top: 5px;"><span>Total Reembolsos:</span><span style="color: #dc3545;">-$${totalReembolsos.toFixed(2)}</span></div>`;
			}
			reporteHtml += `</div>`;
		}

		const montoInicial = parseFloat(datos.basica.monto_inicial || 0);
		const ventasDelDia = parseFloat(datos.basica.ventas_dia || datos.detalles.total || 0);
		const descuentosDelDia = parseFloat(datos.detalles.descuentos_total || 0);
		const reembolsosDelDia = parseFloat(datos.detalles.reembolsos_total || datos.basica.reembolsos_dia || 0);
		const totalCaja = montoInicial + ventasDelDia - reembolsosDelDia;

		reporteHtml += `
			<div class="reporte-seccion">
				<div class="reporte-seccion-titulo">RESUMEN</div>
				<div class="reporte-linea"><span>Monto Inicial:</span><span>$${montoInicial.toFixed(2)} / Bs. ${parseFloat(datos.basica.monto_inicial_bs || 0).toFixed(2)}</span></div>
				<div class="reporte-linea"><span>Ventas del Día:</span><span>$${ventasDelDia.toFixed(2)}</span></div>`;
		if (descuentosDelDia > 0) {
			reporteHtml += `<div class="reporte-linea"><span>Descuentos aplicados:</span><span style="color: #e65100;">-$${descuentosDelDia.toFixed(2)}</span></div>`;
		}
		if (reembolsosDelDia > 0) {
			reporteHtml += `<div class="reporte-linea"><span>Reembolsos del Día:</span><span style="color: #dc3545;">-$${reembolsosDelDia.toFixed(2)}</span></div>`;
		}
		reporteHtml += `
				<div class="reporte-linea" style="font-weight: bold; border-top: 2px solid #333; margin-top: 10px; padding-top: 10px; font-size: 1.2em;"><span>TOTAL EN CAJA:</span><span>$${totalCaja.toFixed(2)}</span></div>
			</div>
			<div class="reporte-footer"><p>Sistema POS - Reporte generado automáticamente</p><p>Impreso el: ${fechaReporte}</p></div>
		</div>`;

		openPrintWindow(win, `Reporte de Caja - ${datos.basica.caja_id}`, reporteHtml, () => {
			if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion('Reporte enviado a impresión', 'success');
		}, 'reporte');
	};

	win.imprimirCierre = function imprimirCierre() {
		if (win._posknUltimoCierre && win._posknUltimoCierre.cerrado === false) {
			const msg = 'No se imprime ticket de cierre: la caja no está confirmada como cerrada.';
			if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion(msg, 'error');
			else win.alert(msg);
			return;
		}
		if (!win.datosCierre) {
			const msg = 'No hay datos de cierre para imprimir';
			if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion(msg, 'error');
			else win.alert(msg);
			return;
		}

		const datos = win.datosCierre;
		const ahora = new Date();
		const fechaReporte = `${ahora.toLocaleDateString('es-ES')} ${ahora.toLocaleTimeString('es-ES')}`;
		const usuarioActual = getUserDisplayName(win);
		const fmt = win.formatearNombreMetodo;
		const sym = win.obtenerSimboloMoneda;

		let reporteHtml = `
			<div class="reporte-impresion">
				<div class="reporte-header">
					<h1 class="reporte-titulo">CIERRE DE CAJA</h1>
					<p class="reporte-fecha">Fecha: ${fechaReporte}</p>
					<p class="reporte-fecha">Usuario: ${usuarioActual}</p>
					<p class="reporte-fecha">Caja ID: ${datos.caja_id}</p>
				</div>
				<div class="reporte-seccion">
					<div class="reporte-seccion-titulo">RESUMEN FINANCIERO</div>
					<div class="reporte-linea"><span>Monto Inicial:</span><span>$${parseFloat(datos.monto_inicial || 0).toFixed(2)} / Bs. ${parseFloat(datos.monto_inicial_bs || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Ventas del Día:</span><span>$${parseFloat(datos.ventas_total || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Ventas realizadas USD:</span><span>$${parseFloat(datos.detalles?.total_usd ?? 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Ventas realizadas Bs:</span><span>Bs. ${parseFloat(datos.detalles?.total_bs ?? 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Total Esperado:</span><span>$${parseFloat(datos.total_esperado || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Monto Declarado:</span><span>$${parseFloat(datos.monto_cierre || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Diferencia:</span><span>$${parseFloat(datos.diferencia || 0).toFixed(2)}</span></div>
					<div class="reporte-linea"><span>Pedidos Procesados:</span><span>${datos.pedidos_count || 0}</span></div>
				</div>`;

		if (datos.detalles?.metodos_pago && Object.keys(datos.detalles.metodos_pago).length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">MÉTODOS DE PAGO</div>`;
			Object.entries(datos.detalles.metodos_pago).forEach(([metodo, monto]) => {
				reporteHtml += `<div class="reporte-linea"><span>${fmt(metodo)}:</span><span>${sym(metodo)}${parseFloat(monto).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		const creditosTotal = parseFloat(datos.detalles?.creditos_total || 0);
		const creditosLista = datos.detalles?.creditos_pedidos || [];
		if (creditosTotal > 0 || creditosLista.length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">CRÉDITOS</div>`;
			reporteHtml += `<div class="reporte-linea"><span>Total a crédito:</span><span style="color:#c62828;">$${creditosTotal.toFixed(2)}</span></div>`;
			creditosLista.forEach((c) => {
				const num = String(c.numero || c.order_id || '');
				const cli = String(c.cliente || '').trim();
				reporteHtml += `<div class="reporte-linea"><span>#${num}${cli ? ` · ${cli}` : ''}:</span><span style="color:#c62828;">$${parseFloat(c.monto || 0).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		const abonosUsdCierre = parseFloat(datos.detalles?.abonos_credito_total_usd || 0);
		const abonosBsCierre = parseFloat(datos.detalles?.abonos_credito_total_bs || 0);
		const abonosListaCierre = datos.detalles?.abonos_credito || [];
		if (abonosUsdCierre > 0 || abonosBsCierre > 0 || abonosListaCierre.length > 0) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">ABONOS DE CRÉDITO</div>`;
			reporteHtml += `<div class="reporte-linea"><span>Total cobrado:</span><span>$${abonosUsdCierre.toFixed(2)}${abonosBsCierre > 0 ? ` / Bs. ${abonosBsCierre.toFixed(2)}` : ''}</span></div>`;
			reporteHtml += `<div class="reporte-linea"><span>Nota:</span><span>Incluidos en métodos de pago</span></div>`;
			abonosListaCierre.forEach((a) => {
				const mon = String(a.moneda || 'USD').toUpperCase() === 'BS' ? 'Bs. ' : '$';
				const met = a.metodo_pago ? ` · ${fmt(a.metodo_pago)}` : '';
				reporteHtml += `<div class="reporte-linea"><span>${a.descripcion || 'Abono'}${met}:</span><span>${mon}${parseFloat(a.monto || 0).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		if (datos.detalles?.productos_vendidos?.length) {
			reporteHtml += `<div class="reporte-seccion"><div class="reporte-seccion-titulo">PRODUCTOS VENDIDOS</div>`;
			datos.detalles.productos_vendidos.forEach((producto) => {
				const qty = parseInt(producto.quantity, 10) || 0;
				const name = String(producto.name || '').normalize('NFC');
				reporteHtml += `<div class="reporte-linea"><span>${qty}x ${name}:</span><span>$${parseFloat(producto.total).toFixed(2)}</span></div>`;
			});
			reporteHtml += `</div>`;
		}

		const estadoFinal = parseFloat(datos.diferencia || 0) >= 0 ? 'CUADRADA' : 'DESCUADRADA';
		const colorEstado = parseFloat(datos.diferencia || 0) >= 0 ? '#28a745' : '#dc3545';
		reporteHtml += `
			<div class="reporte-total" style="background-color: ${colorEstado}; color: white;">CAJA ${estadoFinal}: $${parseFloat(datos.diferencia || 0).toFixed(2)}</div>
			<div class="reporte-footer"><p>Sistema POS - Cierre de Caja</p><p>Cerrado el: ${fechaReporte}</p><p>Usuario: ${usuarioActual}</p></div>
		</div>`;

		openPrintWindow(win, `Cierre de Caja - ${datos.caja_id}`, reporteHtml, () => {
			if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion('Cierre enviado a impresión', 'success');
		}, 'cierre');
	};

	win.abrirNuevaCaja = function abrirNuevaCaja() {
		if (typeof win.iniciarNuevaSesionCaja === 'function') {
			win.iniciarNuevaSesionCaja();
			return;
		}
		if (!win.confirm('¿Deseas abrir una nueva caja con $0.00 / Bs. 0.00 de monto inicial?')) return;
		win.POSKN.api.openCaja(0, 0, 20000)
			.then((response) => {
				if (response.success) {
					if (typeof win.mostrarNotificacion === 'function') {
						win.mostrarNotificacion('Nueva caja abierta con $0.00', 'success');
					}
					if (typeof win.cargarEstadoCaja === 'function') win.cargarEstadoCaja();
				} else if (typeof win.mostrarNotificacion === 'function') {
					win.mostrarNotificacion(`Error: ${response.data}`, 'error');
				}
			})
			.catch(() => {
				if (typeof win.mostrarNotificacion === 'function') {
					win.mostrarNotificacion('Error de conexión al abrir nueva caja', 'error');
				}
			});
	};
}
